import React, { useEffect } from 'react';
import { MapContainer, TileLayer, useMap, ZoomControl } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import MapMarker from "./MapMarker";
import L, { MarkerCluster } from "leaflet";
import './DateLegend.css';
import CutLegendControl from './CutLegendControl/CutLegendControl';
import styled from 'styled-components';
// import { cutStepDetails } from './cutStepDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { screenWidth } from 'utility/screen-width';

function UpdateMapView({ coordinates, mapZoom, cuts }) {
    const map = useMap();

    useEffect(() => {
        if (cuts !== 0) {
            map.setView(coordinates, mapZoom);
        } else if (cuts === 0) {
            map.setView(coordinates, mapZoom);
        }
    }, [map, mapZoom, coordinates, cuts]);

    return null;
}

function TitleControl({title, subtitle}) {
    return (
        <StyledTitleControl className='leaflet-top leaflet-center'>
            <div className="leaflet-control info legend">
                <StyledTitleControlHeader><FontAwesomeIcon icon={duotone('eye')} style={{marginRight: '8px', color: '#0065c4'}} />{title}</StyledTitleControlHeader>
            </div>
            {subtitle && (
                <div className="leaflet-control info legend">
                    <StyledTitleControlSubHeader>{subtitle}</StyledTitleControlSubHeader>
                </div>
            )}
        </StyledTitleControl>
    )
}

const createClusterCustomIcon = function (cluster = MarkerCluster) {
    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: 'custom-marker-cluster',
      iconSize: L.point(35, 35, true),
    })
  }

function MapView({
    cuts,
    refreshCuts,
    loading,
    setLoading,
    title,
    handleFilterSubmit,
    inputs,
    setInputs,
    initialState,
    centerCoordinates,
    newZoom,
    subtitle,
}) {

  return (
    <MapContainer center={centerCoordinates} zoom={newZoom} zoomControl={false} scrollWheelZoom={true} maxZoom={18} style={{ height:'calc(100vh - 70px)', width:'100%'}} dragging={true}>
        <UpdateMapView coordinates={centerCoordinates} mapZoom={newZoom} cuts={cuts?.length} />
        <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MarkerClusterGroup
            iconCreateFunction={createClusterCustomIcon}
            maxClusterRadius={2}
            spiderfyOnMaxZoom={true}
            chunkedLoading={true}
            showCoverageOnHover={false}
        >
        {!loading && cuts?.length && cuts.map(cut => (
            <MapMarker
                coordinates={[cut.latitude, cut.longitude]}
                id={cut.id}
                address={cut.address}
                street={cut.street}
                state={cut.state}
                zipcode={cut.zipcode}
                client={cut?.project?.client?.name}
                date={cut?.project?.orderDate}
                weight={cut.calculateOriginalUOM + ' ' + cut.unit}
                key={'marker' + cut.id}
                projectNumber={cut?.project?.projectNumber}
                orderDate={cut?.project?.orderDate}
                originalDepth={cut.originalDepth}
                originalLength={cut.originalLength}
                originalWidth={cut.originalWidth}
                actualDepth={cut.actualDepth}
                actualLength={cut.actualLength}
                actualWidth={cut.actualWidth}
                comments={cut.comments}
                steps={cut.steps.map(step => (
                       <span>{step.label}</span>
                ))}
                cut={cut}
                refreshCuts={refreshCuts}
                setLoading={setLoading}
            />
        ))}
        </MarkerClusterGroup>
        <TitleControl title={title} subtitle={subtitle} />
        <ZoomControl position='topright'/>
        {/* <StepColorLegendControl /> */}
        <CutLegendControl
            handleFilterSubmit={handleFilterSubmit}
            cuts={cuts}
            inputs={inputs}
            setInputs={setInputs}
            refreshCuts={refreshCuts}
            initialState={initialState}
            // sidebarFilterSubmitted={sidebarFilterSubmitted}
            // setSidebarFilterSubmitted={setSidebarFilterSubmitted}
        />
    </MapContainer>
  );
}

export default MapView;

const StyledTitleControlHeader = styled.h3`
    @media ${screenWidth.below.sm} {
        font-size: 16px;
    }
`;

const StyledTitleControlSubHeader = styled.h5`
    @media ${screenWidth.below.sm} {
        font-size: 14px;
    }
`;

const StyledTitleControl = styled.div`
    @media ${screenWidth.below.md} {
        margin-top: 68px !important;
    }

    @media ${screenWidth.below.sm} {
        max-width: 90%;
        margin: 0 auto;
    }   
`;
